import React, { forwardRef } from 'react';
import Popup from 'devextreme-react/popup';
import '../../styles/common/EditPopup.scss';
export { Position, ToolbarItem } from 'devextreme-react/popup';

// Route all dismissal methods through the caller's existing cancel/unsaved-change handler.
const AppPopup = forwardRef(({ onHiding, onShown, showCloseButton, hideOnOutsideClick, maxWidth, maxHeight, wrapperAttr, ...props }, ref) => {
  const dismissible = typeof onHiding === 'function' && showCloseButton !== false;
  return <Popup
    {...props}
    ref={ref}
    maxWidth={maxWidth == null ? 'calc(100vw - 24px)' : `min(${typeof maxWidth === 'number' ? maxWidth + 'px' : maxWidth}, calc(100vw - 24px))`}
    maxHeight={maxHeight == null ? 'calc(100dvh - 24px)' : `min(${typeof maxHeight === 'number' ? maxHeight + 'px' : maxHeight}, calc(100dvh - 24px))`}
    wrapperAttr={{ ...wrapperAttr, class: [wrapperAttr?.class, 'app-popup--responsive'].filter(Boolean).join(' ') }}
    showCloseButton={dismissible}
    hideOnOutsideClick={dismissible ? (hideOnOutsideClick ?? true) : false}
    onHiding={event => {
      if (!dismissible) { event.cancel = true; return; }
      onHiding?.(event);
    }}
    onShown={event => {
      event.component.registerKeyHandler('escape', () => {
        if (dismissible) event.component.hide();
      });
      onShown?.(event);
    }}
  />;
});

export { AppPopup as Popup };
export default AppPopup;
